module.exports = __webpack_public_path__ + "assets/images/COD.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/COD.png
// module id = 1348
// module chunks = 1